'use client'

import React from 'react'

type Props = {
    buoyantForceN: number
    weightN: number
    buoyantLabel: string
    weightLabel: string
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 44
const PAD_RIGHT = 20
const PAD_TOP = 14
const PAD_BOTTOM = 30
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM
const BAR_W = 70
const GAP = 50

export default function BuoyancyChart({ buoyantForceN, weightN, buoyantLabel, weightLabel }: Props) {
    const maxVal = Math.max(buoyantForceN, weightN, 0.0001) * 1.15

    const yToSvg = (v: number) => PAD_TOP + PLOT_H - (v / maxVal) * PLOT_H

    const x1 = PAD_LEFT + (PLOT_W - 2 * BAR_W - GAP) / 2
    const x2 = x1 + BAR_W + GAP

    const y1 = yToSvg(buoyantForceN)
    const y2 = yToSvg(weightN)

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={HEIGHT - PAD_BOTTOM} x2={WIDTH - PAD_RIGHT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <text x={4} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">N</text>

            <rect x={x1} y={y1} width={BAR_W} height={HEIGHT - PAD_BOTTOM - y1} fill="#2563eb" opacity={0.75} />
            <text x={x1 + BAR_W / 2} y={HEIGHT - PAD_BOTTOM + 14} fontSize={10} textAnchor="middle" fill="#374151">{buoyantLabel}</text>
            <text x={x1 + BAR_W / 2} y={y1 - 6} fontSize={10} textAnchor="middle" fill="#2563eb">{buoyantForceN.toFixed(2)}</text>

            <rect x={x2} y={y2} width={BAR_W} height={HEIGHT - PAD_BOTTOM - y2} fill="#dc2626" opacity={0.75} />
            <text x={x2 + BAR_W / 2} y={HEIGHT - PAD_BOTTOM + 14} fontSize={10} textAnchor="middle" fill="#374151">{weightLabel}</text>
            <text x={x2 + BAR_W / 2} y={y2 - 6} fontSize={10} textAnchor="middle" fill="#dc2626">{weightN.toFixed(2)}</text>
        </svg>
    )
}
